import { PublicSettings } from '@witkac/kartamiejska-shared';
import { RouteConfig } from 'vue-router';

import store from '@/store';
import Home from '@/views/main/Home.vue';
import { benefitFilters } from '@/utils/benefit';

export const homeRoute: RouteConfig = {
  path: 'home',
  component: Home,
  name: 'home',
  beforeEnter(to, from, next) {
    Promise.all([
      store.dispatch('settings/get', PublicSettings.CARD_STATE_COLOR),
      store.dispatch('settings/get', PublicSettings.NO_GROUP_SELECTED_NAME),
      store.dispatch('benefit/list', benefitFilters(to, { count: 1, intendedForUser: true }))
    ]).then(() => next());
  }
};
